import React from 'react'
import * as yup from 'yup'

import createSingularContainer from '@components/Singular/createSingularContainer'
import { FormGroup } from '@modules/form/form.module'
import { 
	getTableColumns,
	rowLinks as clientRowLinks
} from '@scenes/Clients/ClientListContainer'
import DataTable from '@components/DataTable/DataTable'

import { AdminModel } from '@modules/user/user.module'

// TODO: make sorting work on local data tables and remove this 
const tableColumns = getTableColumns().map(col => {
	col.sortKey && delete col.sortKey;
	return col;
});

window.AdminModel = AdminModel;

AdminModel.startFieldBuffer();

const formConfig = [
	{
		label: "System details",
		fields: AdminModel.getFieldProps([
			'profileImage',
			'status',
			'role',
			'payrollNo',
		])
	},
	{
		label: "Personal details",
		fields: AdminModel.getFieldProps([
			'name',
		]),
	},
	{
		label: "Contact details",
		fields: AdminModel.getFieldProps([
			'email',
			'mobile',
			'address',
		]),
	},
	{
		label: "Documents",
		fields: AdminModel.getFieldProps([
			['documents', {
				label: ''
			}],
		]),
	},
	{
		label: "Account",
		showOnNewOnly: true,
		fields: AdminModel.getFieldProps([
			['password', {
				show: ({ isNew }) => isNew,
			}],
			'passwordConfirm',
		]),
	}
];

const fieldPaths = AdminModel.endFieldBuffer();
const _cachedSchemas = {};

export default createSingularContainer({
	title: (data) => data && data.name ? `${data.name.first} ${data.name.last}` : '',
	resource: AdminModel.resourceKey,
	defaultValues: AdminModel.getDefaults(),
	formConfig,
	supportsDeleting: true,

	renderAfterForm: ({data, isNew}) => (
		<React.Fragment>
			{
				!isNew && data.clients && Boolean(data.clients.length) &&
				<div>
					<h2>{data.name.first}'s Clients</h2>
					<DataTable 
						columns={tableColumns}
						rowLinks={clientRowLinks}
						data={data.clients} 
					/>
				</div>
			}
		</React.Fragment>
	),
	validationSchema: ({ isNew }) => {
		// TODO: add auto caching to validation schema based on repeat args? (or perhaps manual key?)
		const newState = isNew.toString();
		if(!_cachedSchemas[newState]) {
			_cachedSchemas[newState] = AdminModel.getValidationSchema(fieldPaths, { isNew, strictMode: true });
		}
		return _cachedSchemas[newState];
	},
	createdString: 'Joined',
	displayAsAccordion: true,
});




// WEBPACK FOOTER //
// ./src/scenes/Consultants/ConsultantContainer.jsx